/** Max width (px) of the centered chat reading column. The composer pill
 *  matches this so input and messages align. */
export const CHAT_COLUMN_MAX_WIDTH = 760;

/** Horizontal gutter (MUI spacing units) the reading column keeps from the
 *  viewport edge on narrow screens, so messages and the composer never touch
 *  the edge on tablets / split-screen. Each column consumer applies this via
 *  `px` on its scroll/centering wrapper. */
export const CHAT_COLUMN_GUTTER = { xs: 1.5, sm: 2.5 } as const;

/** Spreadable sx for the reading column itself: full width, capped, centered.
 *  Combine with the layout-specific props (display/flexDirection) at each call
 *  site. Pair with `CHAT_COLUMN_GUTTER` on the parent for edge breathing room. */
export const chatColumnSx = {
  width: "100%",
  maxWidth: CHAT_COLUMN_MAX_WIDTH,
  mx: "auto",
} as const;
